import { apiEndpoint } from "@/services/map-town";
import {
  setCurrentStep,
  setIsFinalStep,
  toggleModal,
  toggleSubmitted,
  toggleUnsureVisible,
} from "@/store/slices/GlobalSlice";
import { Checkbox, Input, message, Select } from "antd";
import axios from "axios";
import FormData from "form-data";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import BtnGreen from "../BtnGreen";

const { Option } = Select;

const TownDetails = (props) => {
  const { townList, uploadedImagesStep1 } = useSelector(
    (state) => state.globalSlice
  );
  const dispatch = useDispatch();

  const { register, control, formState, handleSubmit, reset, watch, setValue } =
    useForm();

  const onSubmit = async (data) => {
    const requestData = new FormData();

    requestData.append("full_name", data.TownForm.fullName);
    requestData.append("email_address", data.TownForm.email);
    requestData.append("town_id", data.TownForm.town);
    requestData.append("house_id", uploadedImagesStep1?.house_id);

    const config = {
      method: "POST",
      url: `${apiEndpoint}v1/houses/complete`,
      data: requestData,
    };

    try {
      const response = await axios(config);

      if (response.status == 200) {
        reset();
        dispatch(toggleSubmitted());
        dispatch(setIsFinalStep());
        dispatch(setCurrentStep("thankyou"));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUnSure = () => {
    dispatch(toggleUnsureVisible());
  };

  return (
    <div className="form_upload_wrapper max-w-580 mx-auto">
      <div className="mb-8 text-center">
        <h2 className="text-28 font-semibold">Step 3: Submit your details</h2>
      </div>

      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <figure>
            <Controller
              render={({ field }) => (
                <Input
                  {...field}
                  placeholder="Full Name"
                  className={`${
                    formState.errors.TownForm?.fullName && "error-field"
                  }`}
                />
              )}
              name={`TownForm.fullName`}
              control={control}
              rules={{ required: true }}
            />

            <div style={{ color: "red" }}>
              {formState.errors.TownForm?.fullName && (
                <p>Field cannot be empty</p>
              )}
            </div>
          </figure>

          <figure>
            <Controller
              render={({ field }) => (
                <Input
                  {...field}
                  placeholder="Email"
                  type="email"
                  className={`${
                    formState.errors.TownForm?.email && "error-field"
                  }`}
                />
              )}
              name={`TownForm.email`}
              control={control}
              rules={{
                required: true,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: "Enter a valid e-mail address",
                },
              }}
            />

            <div style={{ color: "red" }}>
              {formState.errors.TownForm?.email && <p>Field cannot be empty</p>}
            </div>
          </figure>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2">
            <Controller
              render={({ field }) => (
                <Select
                  {...field}
                  placeholder="Town"
                  style={{ width: "100%" }}
                  className={`${
                    formState.errors.TownForm?.town && "error-field"
                  }`}
                >
                  {townList?.map((option, index) => {
                    return (
                      <Option key={option.id} value={option.term_id}>
                        {option.name}
                      </Option>
                    );
                  })}
                </Select>
              )}
              rules={{ required: true }}
              name={`TownForm.town`}
              control={control}
            />

            <div style={{ color: "red" }}>
              {formState.errors.TownForm?.town && <p>Field cannot be empty</p>}
            </div>
          </div>
        </div>

        <div className="text-sm">
          Unsure of which town to select? Click{" "}
          <span
            className="cursor-pointer font-semibold text-sgbc-blue-400 underline"
            onClick={handleUnSure}
          >
            here
          </span>{" "}
          to see which town you’re located in based on your postal code.
        </div>

        <div>
          <Controller
            render={({ field }) => (
              <Checkbox {...field} defaultChecked={true}>
                <figure className="space-y-4">
                  <span className="text-lg">
                    By submitting the entry, you agree that:
                  </span>
                </figure>
              </Checkbox>
            )}
            rules={{ required: true }}
            defaultValue={true}
            name={`TownForm.agree`}
            control={control}
          />

          <div style={{ color: "red" }}>
            {formState.errors.TownForm?.agree && <p>Field cannot be empty</p>}
          </div>

          <ul className="space-y-4 list-disc list-inside">
            <li>
              SGBC reserves the right to use your personal details and images
              submitted for marketing and promotional purposes.
            </li>
            <li>
              The submissions, which includes your images and text, is of your
              original design and/or home.
            </li>
            <li>
              SGBC and its partners can contact you to confirm and validate your
              entry should you be shortlisted to win for the Greenest Home Town
              competition. Your email will allow us to contact you in the event
              that you’ve been selected for one of our prizes.
            </li>
          </ul>
        </div>
      </div>

      <div className="text-center mt-10">
        <BtnGreen
          className="space-x-5 text-lg font-semibold cursor-pointer"
          onClick={handleSubmit(onSubmit)}
        >
          <span>Share Your Home</span>

          <span>
            <img src={require("@/assets/images/right-arrow.png")} alt="icon" />
          </span>
        </BtnGreen>
      </div>
    </div>
  );
};

TownDetails.propTypes = {};

export default TownDetails;
